import React from "react";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { useNavigate } from "react-router-dom";

const Header = ({ name, type, hide }) => {
  const formmatedType = type
    ? type.charAt(0).toUpperCase() + type.slice(1)
    : "";
  const navigate = useNavigate();

  return (
    <div className="col-md-6 py-3 d-flex ac-js gap-2 ">
      {!hide && (
        <ArrowCircleLeftIcon
          style={{
            width: "35px",
            height: "35px",
            marginBottom: "10px",
          }}
          onClick={() => navigate(-1)}
        />
      )}

      <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
        {name} {formmatedType}
      </h2>
    </div>
  );
};

export default Header;
